import { useMemo, useState, useEffect, useCallback } from "react";

import io from "socket.io-client";

export const useSocket = (serverPath, user) => {
  const [connect, setConnect] = useState(false);
  const [socket, setSocket] = useState(null);

  const connectSocket = useCallback(() => {
    const currentSocket = io.connect(serverPath, {
      transport: ["websocket"],
      withCredentials: true,
      timeout: 20000,
      query: {
        data: JSON.stringify({
          agent: true,
          token: localStorage.getItem("agent_token"),
        }),
      },
    });
    setSocket(currentSocket);
  }, [serverPath]);

  useEffect(() => {
    socket?.on("connect", () => {
      setConnect(true);
      socket.on("id", (data) => {
        localStorage.setItem("id_videolink", data.id);
      });
    });
  }, [socket]);

  useEffect(() => {
    socket?.on("disconnect", () => {
      setConnect(false);
    });
  }, [socket]);

  return {
    socket,
    connect,
    connectSocket,
  };
};
